/*Copyright (c) 2026. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */

export const parseOptions = (value: string) => {
  return (value || "")
    .split(",")
    .map(item => item.trim())
    .filter(Boolean)
    .map(item => ({
      id: item,
      name: item.charAt(0).toUpperCase() + item.slice(1)
    }));
};
 